<template>
  <div id="SectionEcovadisReviews">
    <UIContainer class="SectionEcovadisReviews__container">
      <div class="SectionEcovadisReviews__content">
        <div class="SectionEcovadisReviews__overall">
          <div>
            <div class="SectionEcovadisReviews__overall-score">85%</div>
            <div class="SectionEcovadisReviews__overall-label">
              of clients achieve
              <strong>Silver</strong>
              or
              <strong>Gold</strong>
              rating
            </div>
          </div>

          <img
            class="SectionEcovadisReviews__badges"
            src="./assets/reviews/badges.avif"
            alt="EcoVadis medals and badges"
            loading="lazy"
          />
        </div>

        <ReviewCard
          class="SectionEcovadisReviews__review-card"
          :rating="5"
          name="Sonia Braska"
          jobTitle="Sustainable Procurement and Engagement Lead"
          companyLogoKey="foxway"
        >
          <template #text>
            <em>
              Sustainalyse has in a structured and professional way helped us
              through the Ecovadis assessment. Their knowledge and insights has
              made the whole process much easier for us, and we've managed to
              achieve our goal of Gold rating.
            </em>
          </template>
        </ReviewCard>
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import ReviewCard from '@/views/components/cards/ReviewCard.vue'
</script>

<style lang="scss" scoped>
#SectionEcovadisReviews {
  background-color: $color-ui-brand-50;

  .SectionEcovadisReviews__content {
    display: flex;
    gap: 1.5rem;
    justify-content: flex-end;
    flex-direction: column;
    align-items: center;

    @include md {
      align-items: unset;
      height: 21.75rem;
      flex-direction: row;
    }
  }

  .SectionEcovadisReviews__overall {
    width: 100%;
    min-width: 0;
    max-width: 25rem;
    display: flex;
    flex-direction: column;
    height: 100%;

    @include md {
      margin-right: auto;
    }
  }

  .SectionEcovadisReviews__overall-score {
    @include font-size-30px();
    font-weight: 600;
    color: $color-ui-brand-700;

    &:not(:first-child) {
      margin-top: 1.25rem;
    }

    @include md {
      @include font-size-60px();
    }
  }

  .SectionEcovadisReviews__overall-stars {
    --size: 32px;
    width: 100%;
    height: 25px;
    margin-left: 0.375rem;
  }
  .SectionEcovadisReviews__overall-label {
    margin-top: 0.25rem;
    margin-bottom: 3rem;
  }

  .SectionEcovadisReviews__overall-cta {
    margin-top: auto;
  }

  .SectionEcovadisReviews__review-card-2 {
    @include md {
      max-width: 23.75rem;
    }
  }

  .ReviewCard {
    width: 100%;
    max-width: 43rem;
  }

  .SectionEcovadisReviews__badges {
    min-width: 0;
    max-height: 7.5rem;
    width: auto !important; // override any global img width:100%
    max-width: none;
    display: block;
    flex: 0 0 auto;
    object-fit: contain;
    object-position: left;
  }

  .SectionEcovadisReviews__review-card {
    box-shadow:
      0px 1px 2px -1px var(--ColorsEffectsShadowsshadow-sm02),
      0px 1px 3px 0px var(--ColorsEffectsShadowsshadow-sm01);
  }
}
</style>
